import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const ImageBox = ({ imageBlob, className }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.imageWrapper, className)}>
      <div className={styles.imageEditWrapper}>
        <img
          className={styles.image}
          src={`data:image/png;base64,${imageBlob}`}
        />
      </div>
    </div>
  );
};

ImageBox.defaultProps = {
  imageBlob: '',
  className: '',
};

ImageBox.propTypes = {
  imageBlob: PropTypes.string,
  className: PropTypes.string,
};
